/**
 * 单个题目view
 */

import React from 'react';
import { formatDate2 } from 'util/index';
import styles from './Item.module.scss';

export interface Item {
    question: string;
    answer_right: string;
    answer_user: string;
    is_right: 0 | 1;
    create_time: number;
    // 答题耗时，毫秒
    cost_ts: number;
}

interface Props {
    item: Item;
}

interface ResultInfo {
    text: string;
    badgeClass: string;
}

// 计算答题结果文案与徽章样式
function getResultInfo(item: Item): ResultInfo {
    if (!item.answer_user) {
        return { text: '未作答', badgeClass: styles.none };
    }
    return item.is_right === 1
        ? { text: '正确', badgeClass: styles.right }
        : { text: '错误', badgeClass: styles.error };
}

// 宝宝答案展示：去掉结尾的 # 等占位符（如「我不会#」）
function cleanUserAnswer(answer: string): string {
    return (answer || '').replace(/#+$/, '');
}

export function ItemView({ item }: Props) {
    const isRight = item.is_right === 1;
    const result = getResultInfo(item);
    const userAnswer = cleanUserAnswer(item.answer_user);
    const timeCost = Math.round(item.cost_ts / 1000);
    // 是否是算数类题目
    const isMath = /^\d+$/.test(item.answer_right);

    if (isMath) {
        let formulaNode;
        if (/\( ?\)/.test(item.question)) {
            // 问题里带括号，把答案放在括号里
            const arr = item.question.split(/\( ?\)/);
            formulaNode = (
                <span className={styles.formula}>{arr[0]}(<span className={styles.originAnswer}>{item.answer_right}</span>){arr[1]}</span>
            );
        } else {
            formulaNode = (
                <span className={styles.formula}>{item.question}<span className={styles.eq}>=</span>{item.answer_right}</span>
            );
        }
        return (
            <div className={styles.view}>
                <div className={styles.top}>
                    <div className={styles.formulaWrap}>{formulaNode}</div>
                    <span className={`${styles.badge} ${result.badgeClass}`}>{result.text}</span>
                </div>
                <div className={styles.meta}>
                    {
                        userAnswer && (
                            <span className={styles.metaItem}>
                                宝宝答案 <span className={isRight ? styles.metaVal : styles.metaWrong}>{userAnswer}</span>
                            </span>
                        )
                    }
                    <span className={styles.metaItem}>耗时 <span className={styles.metaVal}>{timeCost}秒</span></span>
                </div>
                <div className={styles.timeCon}>答题时间 {formatDate2(item.create_time * 1000)}</div>
            </div>
        );
    }

    // 语言类题目
    return (
        <div className={styles.view}>
            <div className={styles.top}>
                <div className={styles.formulaWrap}><span className={styles.formula}>{item.question}</span></div>
                <span className={`${styles.badge} ${result.badgeClass}`}>{result.text}</span>
            </div>
            <div className={styles.meta}>
                {
                    userAnswer && (
                        <span className={styles.metaItem}>
                            宝宝答案 <span className={isRight ? styles.metaVal : styles.metaWrong}>{userAnswer}</span>
                        </span>
                    )
                }
                <span className={styles.metaItem}>正确答案 <span className={styles.metaVal}>{item.answer_right}</span></span>
                <span className={styles.metaItem}>耗时 <span className={styles.metaVal}>{timeCost}秒</span></span>
            </div>
            <div className={styles.timeCon}>答题时间 {formatDate2(item.create_time * 1000)}</div>
        </div>
    );
}
